import { render, staticRenderFns } from "./goal-categories-modal.vue?vue&type=template&id=4e044dc2&scoped=true&"
import script from "./goal-categories-modal.vue?vue&type=script&lang=js&"
export * from "./goal-categories-modal.vue?vue&type=script&lang=js&"
import style0 from "./goal-categories-modal.vue?vue&type=style&index=0&id=4e044dc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e044dc2",
  null
  
)

export default component.exports